// a hook that sets the current url based on the selected thread
import { useHistory } from 'react-router-dom'

export const useSetHistory: () => (threadId: string | null) => void = () => {
  const history = useHistory()

  if (!history) {
    return () => {}
  }

  const location = history.location

  const setHistory = (threadId: string | null): void => {
    // Construct the new URL based on the current path and the selected thread ID
    const params = new URLSearchParams(location.search)
    if (params.get('focusedThreadId') !== threadId) {
      if (!threadId) {
        params.delete('focusedThreadId')
      } else {
        params.set('focusedThreadId', threadId)
      }
      history.push({
        pathname: location.pathname,
        search: params.toString(),
      })
    }
  }

  return setHistory
}
